"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogContent = void 0;
var _Products = require("../components/Products");
var _context = require("../context");
var _jsxRuntime = require("react/jsx-runtime");
const DialogContent = ({
  analytics,
  mode,
  products,
  initialProductCode,
  shared,
  replaceSubscription
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_context.AnalyticsDataProvider, {
  value: analytics,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_context.DialogModeProvider, {
    value: mode,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_context.ProductsProvider, {
      value: products,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_context.ReplaceSubscriptionDataProvider, {
        value: replaceSubscription,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_context.SharedConfigurationProvider, {
          value: shared,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Products.Products, {
            initialProductCode: initialProductCode
          })
        })
      })
    })
  })
});
exports.DialogContent = DialogContent;
